import * as React from 'react'
import { observer } from 'mobx-react'
import { withRouter } from 'react-router'
import Form, { ISubmitEvent } from 'react-jsonschema-form'
import LocalizationStore from '../../../Stores/LocalizationStore'
import HttpActionsService from '../../../Services/HttpActionsService'
// import { IUser, User } from '../../Model/User'
import {
    ChangePasswordFormData,
    uiUserChangePasswordFormSchema,
    validate,
    transformErrors,
    getUserChangePasswordFormSchema
} from '../../../Model/UserChangePasswordForm'
import { Button } from 'react-bootstrap'

export interface IUserChangePasswordPageProps {
    cpdata: ChangePasswordFormData
    match?: object
}

@observer
class UserPage extends React.Component<IUserChangePasswordPageProps> {

    uiSchema: any = uiUserChangePasswordFormSchema

    constructor(props: any) {
        super(props)
    }

    submit(e: ISubmitEvent<any>): void {

        let data = JSON.parse(JSON.stringify(e.formData))

        HttpActionsService.getInstance().changePassword(data)
    }
    
    render() {
        const self = this
        const ls = LocalizationStore.getInstance()
        const { cpdata } = this.props

        return (
            <div className="user row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 blockFormFields">
                <Form
                    schema={getUserChangePasswordFormSchema()}
                    uiSchema={this.uiSchema}
                    onSubmit={(e) => self.submit(e)}
                    formData={cpdata}
                    validate={validate}
                    transformErrors={transformErrors}
                >
                    <Button type="submit">
                        {ls.t('Save')}
                    </Button>
                </Form>
                </div>
            </div>
        )
    }
}

export default withRouter(UserPage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Account/ChangePasswordPage.tsx